// amountChech 输入金额校验 type为保留的小数个数
// 返回校验后的的金额
function amountChech(value,type) {
    let amount = String(value)
        .replace(/[^\d.]/g, "")
        .replace(/\.{2,}/g, ".")
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        // .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //清除“数字”和“.”以外的字符
        if(type == 3) {
            amount = amount.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3");
        } else if(type !=1) {
            amount = amount.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
        } else {
            amount = amount.replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3");
        }
    if (
        (amount > 0 &&
          (amount.indexOf(".") == -1 || !amount.startsWith("0"))) ||
        (amount.indexOf(".") == -1 && amount.length > 1)
    ) {
        //防止输入001 01格式
        if (amount.startsWith("0")) {
            amount = amount.substring(1);
        }
    }
    if(amount.indexOf(".") == 0) {
        amount = '';
    }
    return amount;
}
// 返回正数
function PositiveNumberStringWithZero(value) {
    let integer = ''
  
    integer = String(value).replace(/\D/g,'');
  
    return integer
  }
// 返回正整数
function integerCheck(value){
    let integer = String(value).replace(/^0(0+)|[^\d]+/g,'');
    if(integer.length>1 && integer.indexOf('0') == 0) {
        integer = integer.substring(1);
    }
    return integer
}
export {
    amountChech,
    integerCheck,
    PositiveNumberStringWithZero
}


// WEBPACK FOOTER //
// ./src/util/amountChech.js